import { firebaseService } from './FirebaseService';
import { ref, set } from 'firebase/database';
import { doc, setDoc } from 'firebase/firestore';

class DatabaseInitService {
  private rtdb = firebaseService.getRTDB();
  private db = firebaseService.getDb();

  async initializePresenceSystem() {
    try {
      // Initialize the stats document in Firestore
      await setDoc(doc(this.db, 'user-status', 'stats'), {
        onlineCount: 0,
        totalUsers: 0
      }, { merge: true });

      // Initialize the status node in RTDB if it doesn't exist
      await set(ref(this.rtdb, 'status'), {});

      console.log('Database initialization completed successfully');
    } catch (error) {
      console.error('Error initializing database:', error);
    }
  }
}

export const databaseInitService = new DatabaseInitService();
